export const campaignIds = {
  "october-urgency-messaging-banner": "october-urgency-messaging-banner"
}
